import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AboutDipRoutingModule } from './about-dip-routing.module';
import { AboutDipComponent } from 'src/app/pages/about-dip/about-dip.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ButtonModule } from 'src/app/shared/button/button.module';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { DipAdvantageCardComponent } from 'src/app/shared/dip-advantage-card/dip-advantage-card.component';


@NgModule({
  declarations: [
    AboutDipComponent,
    DipAdvantageCardComponent,
  ],
  imports: [
    CommonModule,
    AboutDipRoutingModule,
    AngularSvgIconModule,
    ButtonModule,
    TranslateModule,
  ],
  providers: [
    TranslatePipe,
  ],
  exports: [
    AboutDipComponent,
  ],
})
export class AboutDipModule { }
